export const CHANNEL_NAMES = {
  DOUBLE_CLICK: 'DoubleClick',
  FACEBOOK: 'Facebook/Instagram',
  OFFLINE: 'Offline',
  REQUEST: 'Request',
}
